import { render, staticRenderFns } from "./VResponses.vue?vue&type=template&id=ee485054"
import script from "./VResponses.vue?vue&type=script&lang=js"
export * from "./VResponses.vue?vue&type=script&lang=js"
import style0 from "./VResponses.vue?vue&type=style&index=0&id=ee485054&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./VResponses.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports